"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var account_activation_1 = require("@pbl/pbl-react-core/lib/models/account-activation");
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    success: false,
    loading: false,
    failure: {}
};
exports.default = (function (state, action) {
    var _a, _b;
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(account_activation_1.ACTIVATE_ACCOUNT):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.FAILURE)(account_activation_1.ACTIVATE_ACCOUNT):
            return __assign(__assign({}, state), { loading: false, failure: ((_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) || action.payload });
        case (0, action_type_util_1.SUCCESS)(account_activation_1.ACTIVATE_ACCOUNT):
            return __assign(__assign({}, state), { success: true, loading: false, failure: {} });
        case account_activation_1.RESET:
            return __assign({}, INITIAL_STATE);
        default:
            return state;
    }
});
//# sourceMappingURL=reducers.js.map